export default (...classes: (false | null | undefined | string)[]) => classes.filter(Boolean).join(' ') || undefined;

/**
 * @example 
    <div className={classNames('this is always applied',
    isTruthy && 'this only when the isTruthy is truthy',
    active ? 'active classes' : 'inactive classes')}>Text</div>  
 */
